import { Button } from '@cian/ui-kit';
import { Filters16 } from '@cian/ui-kit/prev/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './UtilityFiltersContainer.css';
import { BASE_FILTERS_URL, SEO_URL_REGEXP } from './constants';
import { selectFiltersUrl } from '../../selectors/filtersUrl';
import { IApplicationState } from '../../types/redux';

export const UtilityFiltersContainer = () => {
  const filtersUrl = useSelector<IApplicationState, string | null>(selectFiltersUrl);
  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();

      const isSeoUrl = SEO_URL_REGEXP.test(window.location.pathname);
      const searchStringFromLocation = window.location.search;
      const safeFiltersUrlFromState = filtersUrl || BASE_FILTERS_URL;

      setTimeout(() => {
        document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';

        if (isSeoUrl) {
          window.location.href = safeFiltersUrlFromState;
        } else if (searchStringFromLocation) {
          window.location.href = `/nd/search/${searchStringFromLocation}`;
        } else {
          window.location.href = safeFiltersUrlFromState;
        }
      }, 300);
    },
    [filtersUrl],
  );

  return (
    <div className={styles['button']}>
      <Button size="XS" theme="fill_white_primary" beforeIcon={<Filters16 color="primary_100" />} onClick={handleClick}>
        Фильтры
      </Button>
    </div>
  );
};
